// extracted by mini-css-extract-plugin
export default {"container":"Search_container__lLZ72","input":"Search_input__e2zAy","inputDark":"Search_inputDark__i6las","clearAnchor":"Search_clearAnchor__mv-N+","icon":"Search_icon__jhgmD"};